import React, { FC } from "react";
// libs
import Image from "next/image";
import Modal from "react-modal";
// hooks
import { useWindowSize } from "src/hooks";
// components
import Button from "src/components/ui/button";
// const
import { EVariants } from "src/constants/variants";
// theme
import {
  WrongMessage,
  ImageContainer,
  Title,
  Subtitle,
  ButtonContainer,
  ButtonBox,
  ButtonBoxCancel,
} from "./FormWrong.styles";

interface IFormWrong {
  isOpen: boolean;
  handleCloseModal: () => void;
  setStep: (data: number) => void;
}

const FormWrong: FC<IFormWrong> = ({ isOpen, handleCloseModal, setStep }) => {
  const { width } = useWindowSize();

  const overlay = {
    zIndex: 3000,
    backgroundColor: "rgba(46, 46, 46, 0.75)",
  };

  let content: { [key: string]: string } = {
    padding: "24px",
    border: "none",
    width: "100vw",
    borderRadius: "0",
    top: "0px",
    left: "0px",
    bottom: "0px",
    right: "0px",
  };

  if (width >= 768) {
    content = {
      ...content,
      padding: "24px",
      width: "480px",
      height: "300px",
      borderRadius: "8px",
      top: "calc(50% - 150px)",
      left: "calc(50% - 240px)",
    };
  }

  return (
    <Modal isOpen={isOpen} style={{ overlay, content }} onRequestClose={handleCloseModal}>
      <WrongMessage>
        <ImageContainer>
          <Image width={48} height={48} src="/icons/wrong.svg" />
        </ImageContainer>
        <Title>Something went wrong</Title>
        <Subtitle>Drop us a line at support@petsapp.com and we’ll get you set up</Subtitle>
        <ButtonContainer>
          <ButtonBoxCancel>
            <Button
              variant={EVariants.SECONDARY}
              style={{ width: "100%", boxShadow: "none" }}
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
          </ButtonBoxCancel>
          <ButtonBox>
            <Button
              variant={EVariants.PRIMARY}
              style={{ width: "100%", boxShadow: "none" }}
              onClick={() => setStep(1)}
            >
              Try again
            </Button>
          </ButtonBox>
        </ButtonContainer>
      </WrongMessage>
    </Modal>
  );
};

export default FormWrong;
